/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentHistorySummary {
    getFixupPrototypeFunction() { return ComplianceAssessmentHistorySummary.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentHistorySummary>): ComplianceAssessmentHistorySummary {
        let obj = Object.assign(new ComplianceAssessmentHistorySummary(), model);
        ComplianceAssessmentHistorySummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentHistorySummary>): ComplianceAssessmentHistorySummary {
        if (!model) return null;
        return ComplianceAssessmentHistorySummary.newInstance(<ComplianceAssessmentHistorySummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentHistorySummary) {
        if (!obj) return;

        models.ComplianceAssessmentHistorySummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentHistorySummary): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentHistorySummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.policy_success_percentage === undefined) {
            this.policy_success_percentage = 0;
        }
        if (this.categorized_count) {
            models.PolicyCounts.fixupPrototype(this.categorized_count);
        }
    }

    /**
     * Status response of api hit to fetch the summary of compliance assessment.
     */
    status: string;

    /**
     * Status of the assessment job number given as input params.
     */
    assessment_job_status: string;

    /**
     * Totally number of policies in assessment.
     */
    total_count: number;

    /**
     * Percentage of policies in success status by total policies in assessment.
     */
    policy_success_percentage: number;

    /**
     * Number of policies status wise detail.
     */
    categorized_count: models.PolicyCounts;

}
